export default "/images/timeout_active.svg"